(function () {
  'use strict';

  angular.module('app').component('resourceAvailabilityDetail', resourceAvailabilityDetail());

  function resourceAvailabilityDetail() {
    return {
      bindings: {
        item: '<',
        resource: '<',
        onResourceAvailabilitySaved: '&',
        onResourceAvailabilityCanceled: '&',
        // lastResourceAvailability: '<',
      },
      controller: ResourceAvailabilityDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/resources/resource-availabilities/resource-availability-detail/resource-availability-detail.component.html',
    };
  }

  ResourceAvailabilityDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ResourceAvailabilityService',
    'moment',
  ];

  function ResourceAvailabilityDetailComponent(
    config,
    UtilService,
    ResourceAvailabilityService,
    moment
  ) {
    const vm = this;

    // public properties
    // ----------------------
    vm.UtilService = new UtilService(vm);

    let timeOptions = setTimeOptions(config.CHECK_TIMES);

    vm.startTimes = timeOptions;
    vm.endTimes = timeOptions;

    // private properties
    // ----------------------
    let dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      if (!vm.item.id) {
        // new
        vm.createMode = true;

        vm.item = {
          all_day: false,
          on_monday: false,
          on_tuesday: false,
          on_wednesday: false,
          on_thursday: false,
          on_friday: false,
          on_saturday: false,
          on_sunday: false,
        };
      }

      setDatePickers();
    };

    // public methods
    // -----------------------
    vm.selectAllDay = function () {
      if (vm.item.all_day) {
        vm.item.start_time = null;
        vm.item.end_time = null;
      }
    };

    vm.selectStartTime = function (startTime) {
      let startTimeIndex = timeOptions.indexOf(startTime);

      // vm.endTimes = vm.UtilService.reorderArrayStartingAt([...timeOptions], startTimeIndex);

      vm.endTimes = [...timeOptions].slice(startTimeIndex);

      // console.log(startTime.id);
      // console.log(vm.endTimes);

      if (vm.item.end_time) {
        let endTime = timeOptions.find((x) => x.value === vm.item.end_time);

        if (startTime.id > endTime.id) {
          vm.item.end_time =
            timeOptions.length - vm.endTimes.length <= 32
              ? vm.endTimes[32].value
              : vm.endTimes[0].value;
        }
      } else {
        vm.item.end_time =
          timeOptions.length - vm.endTimes.length <= 32
            ? vm.endTimes[32].value
            : vm.endTimes[0].value;
        // vm.item.end_time = vm.endTimes[32].value; // select 8 hours later
      }
    };

    // Create/Update
    vm.saveResourceAvailability = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      // vm.item.start_date = vm.UtilService.startOfDayFormat(vm.item.start_date);
      // vm.item.end_date   = vm.UtilService.endOfDayFormat(vm.item.end_date);

      // vm.item.start_date = vm.UtilService.startOfDayUTCFormat(vm.item.start_date);
      // vm.item.end_date   = vm.UtilService.endOfDayUTCFormat(vm.item.end_date);

      vm.item.start_date = moment(vm.item.start_date).format(config.DATE_FORMAT_DB); // 2021-01-28
      vm.item.end_date = moment(vm.item.end_date).format(config.DATE_FORMAT_DB); // 2021-02-28

      // console.log(vm.item);
      // return;

      vm.sendingForm = true;
      ResourceAvailabilityService.saveResourceAvailability(vm.item, vm.resource.id).then(
        (response) => {
          if (!response.errors) {
            // success
            // important
            vm.item.start_date = moment(vm.item.start_date);
            vm.item.end_date = moment(vm.item.end_date);

            vm.onResourceAvailabilitySaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        }
      );
    };

    vm.cancel = function () {
      vm.onResourceAvailabilityCanceled();
    };

    // private methods
    // -----------------------
    function setTimeOptions(options) {
      let array = [];

      let id = 0;
      options.forEach((time) => {
        array.push({
          id: id,
          value: time.value + ':00',
          label: time.label + ':00' + time.meridian,
        });

        id += 1;

        array.push({
          id: id,
          value: time.value + ':15',
          label: time.label + ':15' + time.meridian,
        });

        id += 1;

        array.push({
          id: id,
          value: time.value + ':30',
          label: time.label + ':30' + time.meridian,
        });

        id += 1;

        array.push({
          id: id,
          value: time.value + ':45',
          label: time.label + ':45' + time.meridian,
        });

        id += 1;
      });

      return array;

      // return array.sort((a, b) => a.id - b.id); // If we want to sort
    }

    function setDatePickers() {
      let onChangeStartDate = () => {
        vm.endDatePickerOptions.minDate = vm.item.start_date;

        // Increase end date value if below // nop or equal
        if (vm.item.end_date && vm.item.end_date < vm.item.start_date) {
          // <=
          vm.item.end_date = moment(vm.item.start_date).endOf('month');
        }
      };

      vm.startDatePickerOptions = vm.UtilService.singleDatePickerOptions({
        dateDisplay: dateDisplay,
        showDropdowns: true,
        onChangeDate: onChangeStartDate,
      });

      vm.endDatePickerOptions = vm.UtilService.singleDatePickerOptions({
        dateDisplay: dateDisplay,
        showDropdowns: true,
      });

      if (vm.createMode) {
        /*if (vm.lastResourceAvailability && vm.lastResourceAvailability.id) {
                    vm.item.start_date = moment(vm.lastResourceAvailability.end_date).add(1, 'days');
                	vm.item.end_date   = moment(vm.lastResourceAvailability.end_date).add(1, 'days').endOf('month');

                    vm.startDatePickerOptions.minDate = moment(vm.item.start_date);
                    vm.endDatePickerOptions.minDate   = moment(vm.item.start_date).add(1, 'days');
                } else {
                	vm.item.start_date = moment();
                	vm.item.end_date   = moment().endOf('month');

                	vm.startDatePickerOptions.minDate = moment();
                	vm.endDatePickerOptions.minDate   = moment().add(1, 'days');
                }*/

        vm.item.start_date = moment();
        vm.item.end_date = moment().endOf('month');

        vm.startDatePickerOptions.minDate = moment();
        vm.endDatePickerOptions.minDate = moment();
      } else {
        vm.item.start_date = moment(vm.item.start_date);
        vm.item.end_date = moment(vm.item.end_date);
      }
    }
  }
})();
